<template>
  <div
    v-if="menu"
    class="menu"
  >
    <div class="menu__aside">
      <div class="menu__aside__top">
        <div class="menu__aside__top__user">
          <div class="menu__aside__top__user__name" :title="user.name + ' ' + user.surname">
            {{ user.name + ' ' + user.surname }}
          </div>
          <div class="menu__aside__top__user__role">
            {{ $store.userRole.name | translate }}
          </div>
        </div>
        <div class="menu__aside__top__close">
          <i class="ri-close-fill" @click="menuClose"></i>
        </div>
      </div>
      <div class="menu__aside__wrap">
        <div class="menu__aside__list is--interactive">
          <div class="menu__aside__list__heading">{{ 'd_ws_aside_change_status' | translate }}</div>
          <ul>
            <li
              v-for="status in statuses"
              :key="status.id"
              :class="{
                'is--active': status.id === $store.currentStatus,
                'is--disabled': $store.currentTicketServicing
              }"
              @click="changeStatus(status.id)">
              <i :class="status.icon"></i>
              <span class="text" :title="(status.hasOwnProperty('default') && status.default) ? $options.filters.translate(status.title) : status.title">
                {{ (status.hasOwnProperty('default') && status.default) ? $options.filters.translate(status.title) : status.title }}
              </span>
              <span class="timer" v-if="status.id === $store.currentStatus">
                <Timer :ticket-time="$store.currentStatusTimestamp" />
              </span>
            </li>
          </ul>
        </div>
        <div class="menu__aside__list">
          <div class="menu__aside__list__heading">{{ 'd_ws_aside_system' | translate }}</div>
          <ul>
            <!--          <li class="is&#45;&#45;active">-->
            <!--            <i class="ri-calendar-check-line"></i>-->
            <!--            Добавить запись-->
            <!--          </li>-->
            <!--          <li @click="openStatsModal">-->
            <!--            <i class="ri-pie-chart-2-line"></i>-->
            <!--            Статистика-->
            <!--          </li>-->
            <li @click="openUserProfileModal">
              <i class="ri-user-line"></i>
              {{ 'd_ws_profile' | translate }}
            </li>
            <li @click="openLanguageModal">
              <i class="ri-global-line"></i>
              {{ 'd_ws_change_language' | translate }}
            </li>
            <!--          <li>-->
            <!--            <i class="ri-settings-6-line"></i>-->
            <!--            Система-->
            <!--          </li>-->
            <li @click="logOut">
              <i class="ri-logout-circle-r-line"></i>
              {{ 'd_ws_logout' | translate }}
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div
      class="menu__overlay"
      @click="menuClose"
    />
  </div>
</template>

<script>
import Timer from "../controls/Timer";

export default {
  props: ['menu'],
  methods: {
    menuClose() {
      this.$emit('menuClose');
    },
    openLanguageModal() {
      this.$modal.show(this.$MODAL_NAME.CHANGE_LANGUAGE)
    },
    openUserProfileModal() {
      this.$modal.show(this.$MODAL_NAME.USER_PROFILE)
    },
    openStatsModal() {
      this.$modal.show(this.$MODAL_NAME.STATS)
    },
    logOut() {
      this.$authService.logout()
    },
    changeStatus(id) {
      if (!this.$store.currentTicket && !this.$store.currentTicketServicing) {
        this.$statusService.changeStatus(id).then(() => {
          this.menuClose();
        });
      }
    }
  },
  computed: {
    user() {
      return this.$store.user;
    },
    statuses() {
      return this.$store.statuses;
    }
  },
  components: {
    Timer
  }
}
</script>

<style lang="scss" scoped>
  .menu {
    position: fixed;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    z-index: 9;
    &__aside {
      width: 360px;
      height: 100vh;
      position: absolute;
      top: 0;
      left: 0;
      background: var(--light-01);
      z-index: 1;
      &__top {
        padding: 16px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 65px;
        border-bottom: 1px solid var(--light-02);
        &__user {
          max-width: 100%;
          overflow: hidden;
          &__name {
            font-size: 12px;
            font-weight: 600;
            line-height: 130%;
            font-feature-settings: 'ss02' on;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
          }
          &__role {
            font-size: 12px;
            line-height: 130%;
            font-feature-settings: 'zero' on;
          }
        }
        &__close {
          margin-left: 20px;
          i {
            font-size: 24px;
            color: var(--label-secondary);
            vertical-align: middle;
            cursor: pointer;
          }
        }
      }
      &__wrap {
        max-height: calc(100% - 64px);
        height: auto;
        overflow: auto;
      }
      &__list {
        &__heading {
          font-weight: 600;
          font-size: 12px;
          line-height: 32px;
          letter-spacing: .5px;
          text-transform: uppercase;
          font-feature-settings: 'zero' on;
          color: var(--label-secondary);
          padding: 0 0 0 16px;
        }
        ul {
          list-style: none;
          li {
            font-size: 12px;
            line-height: 48px;
            display: flex;
            align-items: center;
            cursor: pointer;
            padding: 0 16px 0 4px;
            position: relative;
            text-transform: uppercase;
            font-weight: 500;
            white-space: nowrap;
            max-width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            i {
              font-size: 24px;
              margin: 0 16px 0 12px;
            }
            span.timer {
              color: var(--label-secondary);
              font-size: 12px;
              font-feature-settings: 'zero' on;
              margin-left: auto;
            }
            span.text {
              max-width: 100%;
              width: auto;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
            &.is--active {
              span.text {
                max-width: calc(100% - 110px);
              }
            }
          }
        }
        &.is--interactive {
          ul {
            li {
              color: var(--label-secondary);
              text-transform: none;
              font-weight: 500;
              font-size: 16px;
              &:hover:not(.is--disabled),
              &.is--active:not(.is--disabled) {
                color: var(--label-primary);
                &::after {
                  content: '';
                  width: 4px;
                  height: 100%;
                  top: 0;
                  left: 0;
                  background: var(--accent-blue);
                  opacity: .5;
                  position: absolute;
                }
              }
              &.is--disabled {
                cursor: not-allowed;
              }
            }
          }
        }
      }
    }
    &__overlay {
      position: absolute;
      width: 100vw;
      height: 100vh;
      top: 0;
      left: 0;
      background: rgba(0, 0, 0, 0.32);
      cursor: pointer;
    }
  }

  @media (max-width: 425px) {
    .menu {
      &__aside {
        width: 290px;
      }
    }
  }
</style>
